<template>
  <sfs-base-list-filter
    title="Filter Quote Templates"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :advanced-filter="false"
    :popover-filter="true"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Name or Description"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #popover-filters>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Client"
            label-for="advanced-filter-client_id"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <client-select
              id="advanced-filter-client_id"
              placeholder="All"
              :value="client"
              @input="onClientChange"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Service"
            label-for="advanced-filter-service_id"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <service-select
              id="advanced-filter-service_id"
              placeholder="All"
              :value="service"
              @input="onServiceChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <hr class="mt-0 mb-4">

      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Active or Inactive"
            label-for="advanced-filter-active"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <b-form-radio-group
              id="advanced-filter-active"
              v-model="filters.active"
              :options="activeOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>

<script>
import ClientSelect from '@/components/admin/clients/Select.vue';
import ServiceSelect from '@/components/admin/services/Select.vue';
import listFilterMixin from '@/mixins/listFilterMixin';
import { QUOTE_TEMPLATE_TABLE_COLUMN_OPTIONS, QUOTE_TEMPLATE_TABLE_DEFAULT_COLUMNS, QUOTE_TEMPLATE_TABLE_NAME } from '@/constants/quoteTemplates';

export default {
  name: 'QuoteTemplatesListFilter',
  mixins: [listFilterMixin],
  components: {
    ClientSelect,
    ServiceSelect,
  },
  data() {
    return {
      availableColumns: QUOTE_TEMPLATE_TABLE_COLUMN_OPTIONS,
      tableName: QUOTE_TEMPLATE_TABLE_NAME,
      service: null,
    };
  },
  mounted() {
    this.loadInitialFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = QUOTE_TEMPLATE_TABLE_DEFAULT_COLUMNS;
      this.client = null;
      this.service = null;
      this.applyFilters();
    },
    onClientChange(client) {
      this.filters.client_id = client ? client.id.toString() : '';
      this.client = client;
    },
    onServiceChange(service) {
      this.filters.service_id = service ? service.id.toString() : '';
      this.service = service;
    },
    loadInitialFilters() {
      const loadClient = new Promise((resolve) => {
        if (this.initialFilters.client_id) {
          this.$clientsAPI.get(this.initialFilters.client_id).then((client) => {
            resolve(client);
          });
        } else {
          resolve(null);
        }
      });

      const loadService = new Promise((resolve) => {
        if (this.initialFilters.service_id) {
          this.$servicesAPI.get(this.initialFilters.service_id).then((service) => {
            resolve(service);
          });
        } else {
          resolve(null);
        }
      });

      Promise.all([loadClient, loadService]).then((values) => {
        this.client = values[0];
        this.service = values[1];
        this.applyFilters();
      });
    },
  },
};
</script>
